import { appStore } from '@/store';
import { getExperiment } from '@/lib/experiments';
import { features } from '@/lib/features';
import { isExistingAccountEmailLookupEligible } from './isExistingAccountEmailLookupEligible';

export const handleSignupSuppress = (isExistingAccount: boolean): void => {
  const { ui: uiActions, form: formActions } = appStore.getActions();
  const { onboardOption } = appStore.getState().form;
  const suppressSignup = getExperiment('suppressSignup');

  // Google Pay Later use case does not need to suppress signup
  // as it is always forced signup experience
  // For Google Pay Later we set the existing account message
  // to the right value based on the existing account status

  // Member matching Elmos (FEATURE_EXPAND_MEMBER_MATCHING*) are being removed;
  // allocations are fully in control and the feature is deprecated. Keep showing
  // the existing-account email message for US optional and forced signup flows only,
  // matching prior member-match behavior in the one country where it was ramped which is US.
  // Decision made by engineering and product team as a result of https://paypal.atlassian.net/browse/LI-157143
  if (
    features.isActive('isGooglePayLaterOnly') ||
    isExistingAccountEmailLookupEligible()
  ) {
    uiActions.setShowIsExistingAccountEmailMessage(isExistingAccount);
    return;
  }

  if (suppressSignup) {
    const canBeToggledOn = features.isActive(
      'shouldDisableOnboardToggleForMembers',
    );

    if (isExistingAccount) {
      formActions.updateOnboardOption('guest');
    } else if (
      // Toggle back on if they are in suppress state
      // and change the email to a none member email
      !isExistingAccount &&
      canBeToggledOn &&
      // Only force toggle back on if user has not manually altered toggle
      !onboardOption.isDirty &&
      // Avoid pointless redux state updates if already signup
      // since this is obj it causes rerenders even if it's the same
      onboardOption.value !== 'signup'
    ) {
      formActions.updateOnboardOption('signup');
    }

    uiActions.setShowIsExistingAccountEmailMessage(isExistingAccount);
  }
};
